import React, { useEffect, useRef, useState } from "react";
import { GameBoard } from "./GameBoard/GameBoard";
import './Game.css'
import { useGlobalState } from "../GlobalState";
import { ScoreInterface } from "./UserInterface/UserInterface";

export function Game( { params } ) {


    const [ score, setScore ] = useState(0);

    const [ gameOver, setGameOver] = useState(false);
    
    



    /**
     * Update the entire game.
     * 
     * Run on game board state change.
     * Update score, gameboard
     */
    const update = () =>{

    }


    //<UserInterface></UserInterface>
    return (
       <div className='Game'>
            <GameBoard params={{
                color: 'blue',
                isOutline: true
            }}></GameBoard>  
            <ScoreInterface></ScoreInterface>
       </div>
    );
}